module.exports = __webpack_public_path__ + "static/media/combo-vinho.cfddc200.png";